
/* eslint no-multi-spaces: 0 */

import { isMobile, isIOS, isTablet } from './deviceDetector'

function getActualEventName(eventName) {
  if (!isMobile && !isTablet) {
    return eventName;
  }

  switch (eventName) {
    case 'mousedown':     return 'touchstart';
    case 'mousemove':     return 'touchmove';
    case 'mouseup':       return 'touchend';
    case 'beforeunload':  return isIOS ? 'pagehide' : 'beforeunload';
    default:
      return eventName;
  }
}

export default getActualEventName;
